import App from './App.vue';

export default {
  path: '/CDS_VF_DamageReportList',
  name: 'CDS_VF_DamageReportList',
  component: App,
  meta: {
    pageProperty: {
      title: '事案報告一覧',
      controller: 'CDS_CTR_DamageReportList',
    },
  },
};
